// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file ddtank/common/v1/common.proto (package ddtank.common.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ddtank/common/v1/common.proto.
 */
export const file_ddtank_common_v1_common: GenFile = /*@__PURE__*/
  fileDesc("Ch1kZHRhbmsvY29tbW9uL3YxL2NvbW1vbi5wcm90bxIQZGR0YW5rLmNvbW1vbi52MSIfCgdWZWN0b3IyEgkKAXgYASABKAISCQoBeRgCIAEoAiIcCgtDaGFyYWN0ZXJJZBINCgV2YWx1ZRgBIAEoA0IdqgIaRERUYW5rLkNvbnRyYWN0cy5Db21tb24uVjFiBnByb3RvMw");

/**
 * Posição ou vetor no mapa, em pixels do mapa original (origem no canto superior esquerdo, y para baixo).
 *
 * @generated from message ddtank.common.v1.Vector2
 */
export type Vector2 = Message<"ddtank.common.v1.Vector2"> & {
  /**
   * @generated from field: float x = 1;
   */
  x: number;

  /**
   * @generated from field: float y = 2;
   */
  y: number;
};

/**
 * Describes the message ddtank.common.v1.Vector2.
 * Use `create(Vector2Schema)` to create a new message.
 */
export const Vector2Schema: GenMessage<Vector2> = /*@__PURE__*/
  messageDesc(file_ddtank_common_v1_common, 0);

/**
 * Identificador de personagem. Mantido como mensagem para permitir evoluir (ex.: incluir servidor) sem quebrar contratos.
 *
 * @generated from message ddtank.common.v1.CharacterId
 */
export type CharacterId = Message<"ddtank.common.v1.CharacterId"> & {
  /**
   * @generated from field: int64 value = 1;
   */
  value: bigint;
};

/**
 * Describes the message ddtank.common.v1.CharacterId.
 * Use `create(CharacterIdSchema)` to create a new message.
 */
export const CharacterIdSchema: GenMessage<CharacterId> = /*@__PURE__*/
  messageDesc(file_ddtank_common_v1_common, 1);

